export default {
  'settings.sectionTitle': 'Settings',
};
